/**
 * @Author: derhaod
 * @Date: 2026-01-20
 * @Explain: AI Summary Module
 */
export default {
  // Main page
  'AI.SUMMARY.PAGE.TITLE': 'AI Analytics',
  'AI.SUMMARY.DATA.SOURCE': 'Source:',
  'AI.SUMMARY.CHANNEL.ALL': 'All channels',
  'AI.SUMMARY.DISCORD': 'Discord ',

  // Overview component
  'AI.SUMMARY.OVERVIEW.AI.ANALYTICS': 'AI Analytics',
  'AI.SUMMARY.OVERVIEW.MODEL': 'Model',

  // Sentiment component
  'AI.SUMMARY.SENTIMENT.TITLE': 'Sentiment',
  'AI.SUMMARY.SENTIMENT.DISTRIBUTION': 'Sentiment distribution',
  'AI.SUMMARY.SENTIMENT.TOTAL.ANALYZED': 'Total analyzed messages',
  'AI.SUMMARY.SENTIMENT.PULSE.HOUR': '{num}H sentiment pulse',
  'AI.SUMMARY.SENTIMENT.PULSE.DAY': '{num}-Day sentiment pulse',
  'AI.SUMMARY.SENTIMENT.PULSE.MONTH': 'MTD sentiment pulse',
  'AI.SUMMARY.SENTIMENT.TIMEZONE': 'Timezone',
  'AI.SUMMARY.SENTIMENT.LEGEND': 'Sentiment',
  'AI.SUMMARY.SENTIMENT.SENTIMENT.SCORE': 'Sentiment score',

  // HighValuedMessages component
  'AI.SUMMARY.HIGH.VALUED.TITLE': 'High-valued messages',
  'AI.SUMMARY.HIGH.VALUED.BUG.REPORTS': 'Bug reports',
  'AI.SUMMARY.HIGH.VALUED.SUGGESTIONS': 'Suggestions',
  'AI.SUMMARY.HIGH.VALUED.COMPLIMENTS': 'Compliments',
  'AI.SUMMARY.VIEW.CONTENT': 'View content',
  'AI.SUMMARY.HIGH.VALUED.COLLAPSE': 'Collapse',
  'AI.SUMMARY.ANALYZING': 'AI is analyzing...',
  'AI.SUMMARY.ANALYZING.LABEL': 'AI Analyzing:',
  'AI.SUMMARY.CONTEXTUAL.CONVERSATION': 'Contextual conversation',

  // Sentiment types
  'AI.SUMMARY.SENTIMENT.TYPE.POSITIVE': 'Positive',
  'AI.SUMMARY.SENTIMENT.TYPE.NEGATIVE': 'Negative',
  'AI.SUMMARY.SENTIMENT.TYPE.NEUTRAL': 'Neutral',

  // Thinking texts
  'AI.SUMMARY.THINKING.ANALYZING.DATA': 'Analyzing data...',
  'AI.SUMMARY.THINKING.ORGANIZING.INFO': 'Organizing information...',
  'AI.SUMMARY.THINKING.GENERATING.SUMMARY': 'Generating summary...',

  // 筛选
  'AI.SUMMARY.FILTER.SOURCE': 'Source',
  'AI.SUMMARY.FILTER.SOURCE.LABEL': 'Data source',
  'AI.SUMMARY.FILTER.SOURCE.HEADER': 'DISCORD Server: {serverName}',
  'AI.SUMMARY.FILTER.TIME': 'Time',
  'AI.SUMMARY.FILTER.TIME.LABEL': 'Time range',
  'AI.SUMMARY.FILTER.USER.SCOPE': 'Player',
  'AI.SUMMARY.FILTER.USER.SCOPE.LABEL': 'Player scope',
  'AI.SUMMARY.FILTER.DIALOG.TITLE': 'Edit analysis dimensions',
  'AI.SUMMARY.FILTER.DIALOG.CONFIRM': 'Confirm & Refresh Analysis',
  'AI.SUMMARY.FILTER.USER.SCOPE.PLAYTEST.LABEL':
    'All players in current playtest',
  'AI.SUMMARY.FILTER.USER.SCOPE.SMARTLINK.LABEL': 'All players in SmartLink',
  'AI.SUMMARY.FILTER.USER.SCOPE.DISCORD.LABEL':
    'All users in selected channel(s)',
  'AI.SUMMARY.FILTER.TIME.PAST.DAY': 'Past {num} day(s)',
  'AI.SUMMARY.FILTER.TIME.PAST.MONTH': 'Month-to-Date',
};
